import { connect } from "react-redux";

import ConverterConfig from "../Components/Converters/ConverterConfig";
import {
  getConverterConfig,
  setConfigParam,
  removeConfigParam,
  updateConverterMultipleMdl,
} from "../store/actions/actions";

const mapStateToProps = (state) => {
  return {
    converters: state.converters,
    converterconfig: state.converterconfig,
    locale: state.locale,
  };
};

const mapDispatchToProps = {
  getConverterConfig,
  setConfigParam,
  removeConfigParam,
  updateConverterMultipleMdl,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConverterConfig);
